export default "__VITE_ASSET__DfrvZ7OW__"